/* Buscador inteligente de suras: solo títulos, tolera errores, ordena por parecido. Filtra la grilla del blog o lista resultados (home). */
(function () {
  var MONTHS = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var STOP = {sura:1,suras:1,surah:1,al:1,an:1,as:1,ash:1,at:1,ar:1,az:1,ad:1,el:1,la:1,los:1,las:1,de:1,del:1,the:1};
  var cache = {};

  function norm(s) {
    return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function lev(a, b) {
    var m = a.length, n = b.length, i, j, p, c, t;
    if (!m) return n; if (!n) return m;
    p = []; for (j = 0; j <= n; j++) p[j] = j;
    for (i = 1; i <= m; i++) {
      c = [i];
      for (j = 1; j <= n; j++) {
        t = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + t);
      }
      p = c;
    }
    return p[n];
  }
  function prep(it) {
    var words = norm(it.t).split(' '), cand = words.slice(), nums = [], i;
    for (i = 0; i < words.length; i++) {
      if (/^[0-9]+$/.test(words[i])) nums.push(words[i]);
      if (i < words.length - 1) cand.push(words[i] + words[i + 1]);
    }
    it.cand = cand; it.nums = nums; return it;
  }
  function parse(q) {
    var all = norm(q).split(' ').filter(Boolean), tokens = all.filter(function (t) { return !STOP[t]; });
    return tokens.length ? tokens : all;
  }
  function score(tokens, it) {
    var total = 0, k, t, best, w, s, d, sim, c;
    for (k = 0; k < tokens.length; k++) {
      t = tokens[k]; best = 0;
      if (/^[0-9]+$/.test(t)) {
        best = it.nums.indexOf(t) >= 0 ? 1 : 0;
      } else {
        for (w = 0; w < it.cand.length; w++) {
          s = 0; c = it.cand[w];
          if (c === t) s = 1;
          else if (t.length >= 3 && c.indexOf(t) === 0) s = 0.9;
          else if (t.length >= 4 && c.indexOf(t) > -1) s = 0.7;
          else if (t.length >= 3) {
            d = lev(t, c); sim = 1 - d / Math.max(t.length, c.length);
            if (d <= (t.length > 6 ? 3 : 2) && sim >= 0.6) s = sim * 0.85;
          }
          if (s > best) best = s;
        }
      }
      if (!best) return 0;
      total += best;
    }
    return total / tokens.length;
  }
  function fmt(d) {
    var p = d.split('-'); return parseInt(p[2], 10) + ' de ' + MONTHS[parseInt(p[1], 10) - 1] + ', ' + p[0];
  }
  function loadBlog(handle) {
    if (cache[handle]) return cache[handle];
    var key = 'ai-idx-v3-' + handle, stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
    if (stored && stored.items) {
      stored.items.forEach(prep);
      cache[handle] = Promise.resolve(stored);
      return cache[handle];
    }
    function page(n, acc) {
      return fetch('/blogs/' + handle + '?view=titles&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var j = JSON.parse(txt);
          acc.b = j.b; acc.h = j.h; acc.items = acc.items.concat(j.items);
          return n < j.pages ? page(n + 1, acc) : acc;
        });
    }
    cache[handle] = page(1, { items: [] }).then(function (acc) {
      try { sessionStorage.setItem(key, JSON.stringify({ b: acc.b, h: acc.h, items: acc.items.map(function (i) { return { t: i.t, u: i.u, d: i.d, e: i.e }; }) })); } catch (e) {}
      acc.items.forEach(prep);
      return acc;
    });
    return cache[handle];
  }

  function init(root) {
    var handles = (root.getAttribute('data-blogs') || '').split(',').filter(Boolean);
    var filterMode = root.hasAttribute('data-filter');
    var input = root.querySelector('.ai-search__input'), box = root.querySelector('.ai-search__results');
    var form = root.querySelector('.ai-search__form');
    var data = null, timer, current = [];
    var orig = null, grid = null, pags = [];

    if (filterMode) {
      var wrap = document.querySelector('.main-blog');
      orig = wrap && wrap.querySelector('.blog-articles');
      if (orig) {
        pags = [].slice.call(wrap.querySelectorAll('.pagination-wrapper, nav.pagination'));
        grid = document.createElement('div');
        grid.className = 'blog-articles ai-filter-grid';
        grid.style.display = 'none';
        orig.parentNode.insertBefore(grid, orig.nextSibling);
      } else { filterMode = false; }
    }

    function ensure() {
      if (data) return Promise.resolve(data);
      return Promise.all(handles.map(loadBlog)).then(function (r) { data = r; return r; });
    }
    function showOriginal(on) {
      if (!filterMode) return;
      orig.style.display = on ? '' : 'none';
      pags.forEach(function (p) { p.style.display = on ? '' : 'none'; });
      grid.style.display = on ? 'none' : '';
    }
    function card(r) {
      return '<div class="article-card-wrapper card-wrapper ai-card-wrapper"><article class="ai-card" data-blog="' + esc(r.h) + '"><div class="ai-card__body"><div class="ai-card__top"><span class="ai-card__date">' + esc(fmt(r.d)) + '</span></div><h3 class="ai-card__title"><a href="' + esc(r.u) + '" class="full-unstyled-link">' + esc(r.t) + '</a></h3>' + (r.e ? '<p class="ai-card__excerpt">' + esc(r.e) + '</p>' : '') + '<span class="ai-card__more" aria-hidden="true">Leer entrada →</span></div></article></div>';
    }
    function message(text) {
      box.innerHTML = ''; var p = document.createElement('p'); p.className = 'ai-res__head'; p.textContent = text;
      box.appendChild(p); box.hidden = false;
    }
    function render(list, best, q) {
      if (filterMode) {
        if (!q) { box.hidden = true; showOriginal(true); return; }
        if (!list.length) { grid.innerHTML = ''; showOriginal(false); message('No encontramos ninguna sura con ese número o nombre. Revisa la escritura.'); return; }
        grid.innerHTML = list.map(card).join('');
        showOriginal(false);
        message(best < 0.9 ? 'No hay coincidencia exacta. Las más probables:' : (list.length + (list.length === 1 ? ' resultado' : ' resultados')));
        return;
      }
      box.innerHTML = '';
      if (!q) { box.hidden = true; return; }
      var head = document.createElement('p'); head.className = 'ai-res__head';
      if (!list.length) {
        head.textContent = 'No encontramos ninguna sura con ese número o nombre. Revisa la escritura.';
        box.appendChild(head); box.hidden = false; return;
      }
      head.textContent = best < 0.9 ? 'No hay coincidencia exacta. Las más probables:' : (list.length + (list.length === 1 ? ' resultado' : ' resultados'));
      box.appendChild(head);
      list.forEach(function (r) {
        var a = document.createElement('a'); a.className = 'ai-res'; a.href = r.u; a.setAttribute('data-blog', r.h);
        if (handles.length > 1) { var tg = document.createElement('span'); tg.className = 'ai-res__tag'; tg.textContent = r.b; a.appendChild(tg); }
        var t = document.createElement('span'); t.className = 'ai-res__t'; t.textContent = r.t; a.appendChild(t);
        var d = document.createElement('span'); d.className = 'ai-res__d'; d.textContent = fmt(r.d); a.appendChild(d);
        box.appendChild(a);
      });
      box.hidden = false;
    }
    function run() {
      var q = input.value.trim();
      if (!q) { current = []; render([], 0, ''); return; }
      ensure().then(function (blogs) {
        if (input.value.trim() !== q) return;
        var tokens = parse(q), scored = [];
        blogs.forEach(function (bl) {
          bl.items.forEach(function (it) {
            var s = score(tokens, it);
            if (s >= 0.55) scored.push({ s: s, t: it.t, u: it.u, d: it.d, e: it.e, b: bl.b, h: bl.h });
          });
        });
        scored.sort(function (x, y) { return y.s - x.s || (x.d < y.d ? 1 : -1); });
        var best = scored.length ? scored[0].s : 0;
        current = scored.filter(function (r) { return r.s >= Math.max(0.55, best * 0.8); }).slice(0, filterMode ? 30 : 8);
        render(current, best, q);
      }).catch(function () {
        if (filterMode) showOriginal(true);
        message('No se pudo cargar el buscador. Intenta de nuevo.');
      });
    }
    input.addEventListener('focus', ensure);
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 140); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (filterMode) { run(); return; }
      if (current.length) { window.location.href = current[0].u; } else { run(); }
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; run(); } });
  }
  function boot() { document.querySelectorAll('[data-ai-search]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
